import React from 'react';
import { useAppSelector } from 'redux/hooks';
import { selectCustomers, selectUsers } from 'pages/Settings/redux';
import { guestFacePhotoUrlFromCustomer } from 'utils/guestFacePhoto';
import * as S from './ReportContextUsersPreview.styled';
import {
  ReportContextUser,
  reportContextPersonKind,
  reportContextStandingLabel,
  reportContextUserKey,
} from './reportContextUsers';
import ReportStaffFacePhoto from './ReportStaffFacePhoto';

const ReportContextUsersPreview = ({
  users,
  compact,
}: {
  users: ReportContextUser[],
  compact?: boolean,
}) => {
  const staff = useAppSelector(selectUsers);
  const customers = useAppSelector(selectCustomers);

  if (!users.length) return null;

  return (
    <S.Wrap $compact={compact}>
      <S.Label>In context</S.Label>
      <S.List>
        {users.map((person) => {
          const kind = reportContextPersonKind(person);
          const staffMatch = kind === 'staff'
            ? (staff || []).find((u) => (
              (person.staffId && String(u?.id) === person.staffId)
              || (person.email && String(u?.email || '').trim().toLowerCase() === person.email)
            ))
            : undefined;
          const guestMatch = kind === 'guest'
            ? (customers || []).find((c) => (
              (person.customerId && String(c?.id) === person.customerId)
              || (person.email && String(c?.email || '').trim().toLowerCase() === person.email)
            ))
            : undefined;
          const name = person.username
            || (kind === 'guest' ? guestMatch?.name : staffMatch?.username)
            || (kind === 'guest' ? 'Customer' : 'Staff');
          const photo = kind === 'guest'
            ? guestFacePhotoUrlFromCustomer(guestMatch)
            : staffMatch?.photo;
          return (
            <S.Chip
              key={`${reportContextUserKey(person)}-${person.standing}`}
              $standing={person.standing}
            >
              <ReportStaffFacePhoto
                src={photo}
                name={name}
                standing={person.standing}
              />
              <S.Name>{name}</S.Name>
              <S.Standing $standing={person.standing}>
                {reportContextStandingLabel(person.standing)}
              </S.Standing>
            </S.Chip>
          );
        })}
      </S.List>
    </S.Wrap>
  );
};

export default ReportContextUsersPreview;
